'use client';

import React from 'react';
import { useIsClientCds } from '@/hooks/cds/use-is-client-cds';

/**
 * A React component that conditionally renders its children based on the client-side rendering status.
 *
 * @param {Object} props - The props object.
 * @param {React.ReactNode} props.children - The content to render when the component is on the client-side.
 * @param {React.ReactNode} [props.fallback] - The content to render when the component is not on the client-side. Defaults to null if not provided.
 * @returns {JSX.Element} The rendered content based on the client-side rendering status.
 */
export function IsClientCds({
  children,
  fallback,
}: Readonly<{ children: React.ReactNode; fallback?: React.ReactNode }>) {
  const { isClient } = useIsClientCds();

  return isClient ? <>{children}</> : <>{fallback ?? null}</>;
}
